(function() {
  // Backward compatibility guard for legacy browsers
  if (!window.IntersectionObserver || !window.Proxy) return;

  const OriginalSwiper = window.Swiper;
  if (!OriginalSwiper) return;

  window.Swiper = function(selector, options) {
    const element = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!element) {
      return new OriginalSwiper(selector, options);
    }

    // Determine if the element is close to the viewport (within 300px above/below the fold)
    const rect = element.getBoundingClientRect();
    const isAboveFold = rect.top < window.innerHeight + 300;

    let instance = null;
    let methodQueue = [];

    const initializeRealSwiper = () => {
      if (instance) return;
      instance = new OriginalSwiper(element, options);
      element.swiper = instance;
      
      // Execute any buffered calls
      methodQueue.forEach(({ method, args, resolve }) => {
        if (instance[method]) {
          resolve(instance[method](...args));
        }
      });
      methodQueue = [];
    };

    if (isAboveFold) {
      initializeRealSwiper();
      return instance;
    } else {
      // Intersection Observer to defer initialization of below-the-fold sliders
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            obs.unobserve(entry.target);
            initializeRealSwiper();
          }
        });
      }, { rootMargin: '300px' });
      observer.observe(element);

      // Return a Proxy wrapper to safely absorb early calls (like .on, .update, etc.)
      return new Proxy({}, {
        get(target, prop) {
          if (instance) {
            return instance[prop];
          }
          if (typeof OriginalSwiper.prototype[prop] === 'function') {
            return function(...args) {
              if (instance) {
                return instance[prop](...args);
              }
              if (prop === 'on' || prop === 'off') {
                return new Promise((resolve) => {
                  methodQueue.push({ method: prop, args, resolve });
                });
              }
              initializeRealSwiper();
              return instance[prop](...args);
            };
          }
          return undefined;
        }
      });
    }
  };

  // Copy static properties (e.g. Swiper.use, Swiper.defaults, etc.)
  Object.keys(OriginalSwiper).forEach(key => {
    window.Swiper[key] = OriginalSwiper[key];
  });
  window.Swiper.prototype = OriginalSwiper.prototype;
})();
